export default __webpack_public_path__ + "static/hep-artichoke-d92bec0bfe3f9fd51537797274489dbf.jpg";